// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../../services/bao-menu";
import TabPage from "./../../factories/tab-page";
import finitoService from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/filtering";
function ShiftReportTaskTab(tabPage, shiftReportViewModel) {
    var self = this;
    SubscriptionViewModel.call(this, tabPage);
    self.BaoRouterSubscriptions = [];
    self.Bao = Bao;
    self.ShiftReport = shiftReportViewModel;
    self.ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Selection = ko.observableArray();
    self.CustomFilter = ko.observable({});
    self.TotalRows = ko.observable();
    self.Tasks = ko.observableArray([]);
    self.OriginalTabTitle = self.TabPage.Title();
    self.TotalRows.subscribe(function (value) {
        if (value == null || value == 0) {
            self.TabPage.Title(self.OriginalTabTitle);
            return;
        }
        self.TabPage.Title(self.OriginalTabTitle + " (" + value + ")");
    });
    tabPage.IconLeft("fal fa-calendar-check");
    self.returnToMyself = function (tabToClose) {
        if (tabToClose) {
            self.ShiftReport.TabViewModel.RemoveTab(tabToClose);
            self.ShiftReport.TabViewModel.SelectTab(self.TabPage);
        }
    };
    self.link = function (index, taskModel) {
        if (taskModel) {
            var linkHash = "task/" + taskModel.InstructionId();
            baoRouter.setHash(linkHash);
        }
    };
    self.init = function () {
        tabPage.IsLoading(true);
        return $.Deferred().resolve();
    };
    self.loaded = function () {
        var def = $.Deferred();
        var subscription = baoRouter.routed(function (request, data) {
            self.routeToTask(request);
        });
        self.routeToTask(self.ShiftReport.TabPage);
        Bao.bindEvent("tasks:refresh", function (value) {
            self.getTasks();
        });
        self.ValidDateJs.subscribe(function (validDateJs) {
            self.getNavigation(validDateJs);
        });
        self.subscribe(self.ShiftReport.IsOriginal, function (isOriginal) {
            self.TabPage.IsLoading(true);
            self.getTasks().then(function () {
                self.TabPage.IsLoading(false);
            });
        });
        self.subscribe(self.Sorting, function () {
            self.getTasks();
        });
        self.subscribe(self.PageSize, function () {
            if (self.PageIndex() === 0) {
                self.getTasks();
            }
            else {
                self.PageIndex(0);
            }
        });
        self.subscribe(self.PageIndex, function () {
            self.getTasks();
        });
        self.subscribe(self.CustomFilter, function () {
            self.getTasks();
        });
        tabPage.IsLoading(false);
        def.resolve();
        return def.promise();
    };
    self.dispose = function () {
        ko.utils.arrayForEach(self.BaoRouterSubscriptions, function (subscription) {
            baoRouter.unsubscribe(subscription);
        });
        ko.utils.arrayForEach(self.Subscriptions, function (subscription: any) {
            subscription.dispose();
        });
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
}
;
Bao.inherit(ShiftReportTaskTab, SubscriptionViewModel);
ShiftReportTaskTab.prototype.removeInstructionIdFromRoute = function () {
    var currentHash = baoRouter.getHash(), instructionIdIndex = currentHash.toLowerCase().indexOf('task');
    if (instructionIdIndex !== -1) {
        baoRouter.replaceHash(currentHash.substr(0, instructionIdIndex));
    }
};
ShiftReportTaskTab.prototype.routeToTask = function (tabPage) {
    var reportId = baoRouter.getRouteValue("id", tabPage);
    if (reportId === this.ShiftReport.ReportId()) {
        var instructionId = baoRouter.getRouteValue("instructionid", tabPage);
        if (instructionId) {
            this.removeInstructionIdFromRoute();
            var activeInstructionTab = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveTask");
            if (activeInstructionTab) {
                if (ko.isObservable(activeInstructionTab.ViewModel)) {
                    var instructionViewModel = activeInstructionTab.ViewModel();
                    if (instructionViewModel) {
                        if (instructionViewModel.InstructionId() !== instructionId) {
                            this.createNewInstructionTab();
                            this.edit(instructionId);
                        }
                    }
                }
            }
            else {
                this.createNewInstructionTab();
                this.edit(instructionId);
            }
        }
    }
};
ShiftReportTaskTab.prototype.getTasks = function () {
    var self = this;
    var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
    return Bao.post("TaskTab/GetAll", JSON.stringify({
        id: self.TabPage.FormHistoryId,
        reportId: self.ShiftReport.ReportId(),
        searchFilter: {
            ShowClosedTasks: false
        },
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting(),
        customfilter: customFilter
    })).then(function (result) {
        ko.map.fromJS(result, self);
    });
};
export default ShiftReportTaskTab;